import React, { useEffect, useState } from "react";
import { apiTreeHistory } from "./api";

// Follow-up history for a single node — collapsible list. Backend enforces
// role-based visibility so we render whatever comes back.
export default function FollowUpHistoryPanel({ node }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (!open || !node?.nodeId) return;
    setLoading(true); setErr(null);
    (async () => {
      try {
        const r = await apiTreeHistory(node.nodeId);
        setItems(r.items || []);
      } catch (e) {
        setErr(e?.message || "Failed to load history.");
      } finally { setLoading(false); }
    })();
  }, [open, node?.nodeId]);

  return (
    <div data-testid="followup-history" style={{ marginTop: 12 }}>
      <button
        type="button"
        className="btn btn-outline btn-sm"
        data-testid="fh-toggle"
        onClick={() => setOpen(v => !v)}
        style={{ width: "100%", justifyContent: "space-between", display: "flex", alignItems: "center" }}
      >
        <span>Follow-Up History {items ? `(${items.length})` : ""}</span>
        <span style={{ color: "var(--kc-accent)" }}>{open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div data-testid="fh-list" style={{ marginTop: 8, maxHeight: 260, overflowY: "auto", display: "flex", flexDirection: "column", gap: 6 }}>
          {loading && <div style={{ color: "var(--kc-sub)", fontSize: 12, padding: 6 }}>Loading…</div>}
          {err && <div style={{ color: "#ff6b6b", fontSize: 12, padding: 6 }}>{err}</div>}
          {items && items.length === 0 && <div data-testid="fh-empty" style={{ color: "var(--kc-sub)", fontSize: 12, padding: 6 }}>No follow-ups logged for this member yet.</div>}
          {items && items.map(a => (
            <div key={a.id} data-testid={`fh-item-${a.id}`} style={{ background: "#111", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 8, padding: "8px 10px", fontSize: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8, marginBottom: 2 }}>
                <span style={{ color: "var(--kc-accent)", fontWeight: 700 }}>{a.date}</span>
                <span style={{ color: "var(--kc-sub)" }}>{a.method}</span>
              </div>
              <div style={{ color: "var(--kc-text)" }}>
                by <strong>{a.loggedByName}</strong>{a.loggedByLevelName ? ` · ${a.loggedByLevelName}` : ""}
              </div>
              {a.notes && <div style={{ color: "var(--kc-sub)", marginTop: 4, whiteSpace: "pre-wrap" }}>{a.notes}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
